<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <h5>Histórico</h5>
        </div>
      </div>
      <div class="row">
        <div v-show="!historico.length || historico.length < 1" class="col-md-12">
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary text-center">
            Sem Histórico
          </div>
        </div>
        <div v-show="historico.length && historico.length > 0" class="col-md-12">
          <ul class="list-group">
            <li v-for="h in historico" v-bind:key="h.chm_codigo"
                class="list-group-item mb-3">
              <div class="media">
                <div class="media-body">
                  <h5 class="font-size-14">{{ h.pes_nome }}
                    <span v-if="h.chm_status === '1'"
                          class="badge badge-soft-primary font-size-12">Solicitada</span>
                    <span v-if="h.chm_status === '2'"
                          class="badge badge-soft-info font-size-12">Em Andamento</span>
                    <span v-if="h.chm_status === '3'"
                          class="badge badge-soft-warning font-size-12">Pendente</span>
                    <span v-if="h.chm_status === '4'"
                          class="badge badge-soft-danger font-size-12">Rejeitada</span>
                    <span v-if="h.chm_status === '9'"
                          class="badge badge-soft-success font-size-12">Aprovada</span>
                  </h5>
                  <p class="text-dark">
                    {{ h.chm_motivo }}
                  </p>
                  <p class="text-muted mb-0">{{ h.chm_data | formatDateHora }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="button" @click="voltar()" class="btn btn-label btn-light"><i class="bx bx-exit label-icon"></i>
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "historico-movimento",
  props: {
    historico: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    voltar() {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped>
.list-group-item {
  border-top-width: 1px !important;
}
</style>